$(document).ready(function () {
  $(document).on("click", "#tabs .ui-tabs-nav .ui-tabs-tab", function () {
    $("#tabs .ui-tabs-nav .ui-tabs-tab").removeClass("active");
    $(this).addClass("active");

    var dataId = $(this).attr("data-id");
    $(this).parents("#tabs").find(`.t_tab`).removeClass("active");
    $(this)
      .parents("#tabs")
      .find(`.t_tab[data-id="${dataId}"]`)
      .addClass("active");
  });

  $(document).on(
    "click",
    ".custom-product-tabs-wrapper #accordion .accordian_title",
    function () {
      $(
        ".custom-product-tabs-wrapper #accordion .accordian_title .accordion_content"
      ).removeClass("active");
      $(this).next().toggleClass("active");
    }
  );

  $(document).on("click", ".colletion-faqs-section .faq-que", function () {
    if ($(this).parent(".faqs-warpper").hasClass("active")) {
      $(this).parent(".faqs-warpper").removeClass("active");
    } else {
      $(".colletion-faqs-section .faqs-warpper").removeClass("active");
      $(this).parent(".faqs-warpper").addClass("active");
    }
  });

  $(document).on(
    "click",
    ".custom-imageText-accordian-section .accordion-title",
    function () {
      if ($(this).parent(".accordion-item").hasClass("active")) {
        $(this).parent(".accordion-item").removeClass("active");
      } else {
        $(".custom-imageText-accordian-section .accordion-item").removeClass(
          "active"
        );
        $(this).parent(".accordion-item").addClass("active");
      }
    }
  );

  /*Filter code start */
  var FilterUse = $("#FilterUse").attr("dataurl") + "/";
  $("#FilterUse").on("change", function () {
    if (
      $(this).val() == "" &&
      (window.location.href.indexOf("f_") > -1 ||
        window.location.href.indexOf("s_") > -1)
    ) {
      window.location.href = window.location.href
        .toString()
        .replace(
          "u_" +
            window.location.href.toString().split("u_")[1].split("+")[0] +
            "+",
          ""
        );
    } else if (
      window.location.href.indexOf("u_") > -1 &&
      (window.location.href.indexOf("s_") > -1 ||
        window.location.href.indexOf("f_") > -1)
    ) {
      window.location.href = window.location.href.replace(
        window.location.href.toString().split("u_")[1].split("+")[0],
        $(this).val().replace(/\s+/g, "-").toLowerCase().split("u_")[1]
      );
    } else if (
      window.location.href.indexOf("s_") > -1 &&
      (window.location.href.indexOf("u_") == -1 ||
        window.location.href.indexOf("f_") == -1)
    ) {
      window.location.href =
        location.href + $(this).val().replace(/\s+/g, "-").toLowerCase() + "+";
    } else if (
      window.location.href.indexOf("f_") > -1 &&
      (window.location.href.indexOf("s_") == -1 ||
        window.location.href.indexOf("u_") == -1)
    ) {
      window.location.href =
        location.href + $(this).val().replace(/\s+/g, "-").toLowerCase() + "+";
    } else {
      if (window.location.href.indexOf("+") > -1) {
        window.location.href =
          FilterUse + $(this).val().replace(/\s+/g, "-").toLowerCase();
      } else {
        window.location.href =
          FilterUse + $(this).val().replace(/\s+/g, "-").toLowerCase() + "+";
      }
    }
  }),
    $("#FilterFeatured").on("change", function () {
      if (
        $(this).val() == "" &&
        (window.location.href.indexOf("u_") > -1 ||
          window.location.href.indexOf("s_") > -1)
      ) {
        window.location.href = window.location.href
          .toString()
          .replace(
            "f_" +
              window.location.href.toString().split("f_")[1].split("+")[0] +
              "+",
            ""
          );
      } else if (
        window.location.href.indexOf("f_") > -1 &&
        (window.location.href.indexOf("s_") > -1 ||
          window.location.href.indexOf("u_") > -1)
      ) {
        window.location.href = window.location.href.replace(
          window.location.href.toString().split("f_")[1].split("+")[0],
          $(this).val().replace(/\s+/g, "-").toLowerCase().split("f_")[1]
        );
      } else if (
        window.location.href.indexOf("s_") > -1 &&
        (window.location.href.indexOf("f_") == -1 ||
          window.location.href.indexOf("u_") == -1)
      ) {
        window.location.href =
          location.href +
          $(this).val().replace(/\s+/g, "-").toLowerCase() +
          "+";
      } else if (
        window.location.href.indexOf("u_") > -1 &&
        (window.location.href.indexOf("s_") == -1 ||
          window.location.href.indexOf("f_") == -1)
      ) {
        window.location.href =
          location.href +
          $(this).val().replace(/\s+/g, "-").toLowerCase() +
          "+";
      } else {
        if (window.location.href.indexOf("+") > -1) {
          window.location.href =
            $("#FilterFeatured").attr("dataurl") +
            "/" +
            $(this).val().replace(/\s+/g, "-").toLowerCase();
        } else {
          if (
            $(this).val() == "?sort_by=price-ascending" ||
            $(this).val() == "?sort_by=price-descending"
          ) {
            window.location.href =
              $("#FilterFeatured").attr("dataurl") + $(this).val();
            return false;
          }
          window.location.href =
            $("#FilterFeatured").attr("dataurl") +
            "/" +
            $(this).val().replace(/\s+/g, "-").toLowerCase() +
            "+";
        }
      }
    }),
    $("#Filterstr").on("change", function () {
      if (
        $(this).val() == "" &&
        (window.location.href.indexOf("u_") > -1 ||
          window.location.href.indexOf("f_") > -1)
      ) {
        window.location.href = window.location.href
          .toString()
          .replace(
            "s_" +
              window.location.href.toString().split("s_")[1].split("+")[0] +
              "+",
            ""
          );
      } else if (
        window.location.href.indexOf("s_") > -1 &&
        (window.location.href.indexOf("u_") > -1 ||
          window.location.href.indexOf("f_") > -1)
      ) {
        window.location.href = window.location.href.replace(
          window.location.href.toString().split("s_")[1].split("+")[0],
          $(this)
            .val()
            .replace(/\s+/g, "-")
            .toLowerCase()
            .split("s_")[1]
            .split("+")[0]
        );
      } else if (
        window.location.href.indexOf("u_") > -1 &&
        (window.location.href.indexOf("s_") == -1 ||
          window.location.href.indexOf("f_") == -1)
      ) {
        window.location.href =
          location.href + $(this).val().replace(/\s+/g, "-").toLowerCase();
      } else if (
        window.location.href.indexOf("f_") > -1 &&
        (window.location.href.indexOf("s_") == -1 ||
          window.location.href.indexOf("u_") == -1)
      ) {
        window.location.href =
          location.href + $(this).val().replace(/\s+/g, "-").toLowerCase();
      } else {
        if (window.location.href.indexOf("+") > -1) {
          window.location.href =
            $("#Filterstr").attr("dataurl") +
            "/" +
            $(this).val().replace(/\s+/g, "-").toLowerCase();
        } else {
          window.location.href =
            $("#Filterstr").attr("dataurl") +
            "/" +
            $(this).val().replace(/\s+/g, "-").toLowerCase() +
            "+";
        }
      }
    });

  if (window.location.href.indexOf("price-ascending") > -1) {
    $(`#FilterFeatured option[value="?sort_by=price-ascending"]`).attr(
      "selected",
      "selected"
    );
  }
  if (window.location.href.indexOf("price-descending") > -1) {
    $(`#FilterFeatured option[value="?sort_by=price-descending"]`).attr(
      "selected",
      "selected"
    );
  }

  $("#CustomCurrencyList").addClass("hide");
  $(document).on("click", ".dropdown-currency-switcher", function () {
    $(this)
      .parent("#HeaderCurrency")
      .find("#CustomCurrencyList")
      .toggleClass("hide");
  });

  $(document).on(
    "click",
    "#CustomCurrencyList .currency_list_sub",
    function (event) {
      event.preventDefault();
      var dataIndex = $(this).attr("data-index");
      $(
        `#CurrencyList .disclosure-list__item[data-index="${dataIndex}"] span`
      ).click();
    }
  );

  // Close the dropdown if clicked outside
  $(document).on("click", function (event) {
    var $target = $(event.target);

    // Check if the click is outside the dropdown and switcher button
    if (!$target.closest("#HeaderCurrency").length) {
      $("#CustomCurrencyList").addClass("hide");
    }
  });
});

$(document).on("click", ".custom_cart_button", function () {
  var varId = $(this)
    .closest(".main_custom_variants_cart")
    .find("select option:selected")
    .attr("variant-id");
  console.log("varId", varId);
  window.addToCart(varId);
});

window.addToCart = function (varId) {
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: parseInt(varId),
      quantity: 1,
    },
    dataType: "json",
    success: function (result) {
      console.log("Product added");
    },
  });
};

document.addEventListener('DOMContentLoaded', function() {
  const currencySwitcher = document.getElementById('HeaderCurrency');
  const cartNote = document.querySelector('.cart-note');

  if (currencySwitcher && cartNote) {
      const selectedFlag = currencySwitcher.querySelector('.currency-flag[data-flag]');

      // Check if the selected currency is AUD or USD
      if (selectedFlag) {
          const flag = selectedFlag.getAttribute('data-flag');

          if (flag === 'AUD' || flag === 'USD') {
              cartNote.style.display = 'none'; // Hide the note
          } else {
              cartNote.style.display = 'block'; // Show the note for other currencies
          }
      }
  }
});

// On change price append on select variant option for collection

window.addEventListener('pageshow', function () {
  const variantSelects = document.querySelectorAll('.variant-select');

  variantSelects.forEach(variantSelect => {
    variantSelect.selectedIndex = 0;

    variantSelect.dispatchEvent(new Event('change'));
  });
});


document.addEventListener('DOMContentLoaded', function() {

  window.onVariantChangeCustom = function() {
    const variantSelects = document.querySelectorAll('.variant-select');

    variantSelects.forEach(variantSelect => {
      variantSelect.addEventListener('change', function(e) {
          const selectedIndex = e.target.selectedIndex;

          if (selectedIndex >= 0) {

              const selectedOption = e.target.options[selectedIndex];

              const variantPrice = selectedOption.getAttribute('variant-price');
              const variantcomparePrice = selectedOption.getAttribute('variant-compare-price');

              const priceDisplay = variantSelect.closest('.main_custom_variants_cart').previousElementSibling.querySelector('.product-price');
              const comparepriceDisplay = variantSelect.closest('.main_custom_variants_cart').previousElementSibling.querySelector('.compare-price');
              
              if (variantPrice && priceDisplay) {
                  priceDisplay.textContent = variantPrice;
              } 
              if (variantcomparePrice && comparepriceDisplay) {
                comparepriceDisplay.textContent = variantcomparePrice;
              }
          } else {
              console.error('Selected index is invalid');
          }
      });
    });
  }
  window.onVariantChangeCustom();
});
